import script from "./OverviewContactBlock.vue?vue&type=script&setup=true&lang=ts"
export * from "./OverviewContactBlock.vue?vue&type=script&setup=true&lang=ts"

import "./OverviewContactBlock.vue?vue&type=style&index=0&id=0b5b5294&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b5b5294"]])

export default __exports__